import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { MAINTENANCE_FAIL_MODE_PATH } from '../../../../config/paths';
import MaintenanceFailModeDeleteButton from './MaintenanceFailModeDeleteButton';

const MaintenanceFailModeToolbar = ({ maintenanceFailModeId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton
        path={`${MAINTENANCE_FAIL_MODE_PATH}/${maintenanceFailModeId}/edit`}
      />{' '}
      <MaintenanceFailModeDeleteButton
        maintenanceFailModeId={maintenanceFailModeId}
      />
    </div>
  </ButtonToolbar>
);

MaintenanceFailModeToolbar.propTypes = {
  maintenanceFailModeId: PropTypes.number.isRequired,
};

export default MaintenanceFailModeToolbar;
